var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-flex li-row position-absolute rounded-3 justify-content-center align-items-center",class:{ game: _vm.inTheGame},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.currentLanguageCode)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }